import React from 'react';
import Landing_Section_4 from '../../images/shopify-popup/landing-section-4.png'
import Landing_Section_5 from '../../images/shopify-popup/landing-section-5.png'


class SectionFour extends React.Component {
  render() {
    return (
      <div className="main-container">
        <section className="text-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <h1>
                Boost your sales and collect leads with a conversion guaranteed Shopify popup
                </h1>

                <form
                  className="row justify-content-center form--active"
                  action="http://mrare.us8.list-manage.com/subscribe/post-json?u=77142ece814d3cff52058a51f&amp;id=f300c9cce8&amp;c=?"
                  data-success="Thanks for signing up.  Please check your inbox for a confirmation email."
                  data-error="Please provide your name and email address and agree to the terms."
                  noValidate={true}
                >
                  <div className="col-md-12">
                    <a
                      id="landing--try-now--section4-link"
                      className="btn btn--primary type--uppercase"
                      href="https://dashboard.popupfox.com/register"
                    >
                      <span className="btn__text">TRY NOW</span>
                    </a>
                  </div>

                  <div aria-hidden="true">
                    <input
                      hidden
                      type="text"
                      name="b_77142ece814d3cff52058a51f_f300c9cce8"
                      tabIndex="-1"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section className="switchable">
          <div className="container">
            <div className="row justify-content-around">
              <div className="col-md-12 text-center">
                <iframe
                  width="560" 
                  className='iframe-shopify-popup'               
                  src="https://www.youtube.com/embed/nZcAuJczq-c"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <section className="switchable feature-large">
          <div className="container">
            <div className="row justify-content-around">
              <div className="col-md-6">
                <img src={Landing_Section_5} alt="Image" />
              </div>
              <div className="col-md-6 col-lg-5">
                <div className="switchable__text">
                  <h2>Take advantage of being flexible in marketing strategies</h2>
                  <p className="lead">
                  Popupfox’s Shopify popups are perfect for cross-selling and upselling. Make sure your visitors discover overlooked products
                   or simply recommend upgrades. 
                  </p>
                  <a
                    id="landing--vry-variant-page-builder-now--section5--link"
                    href="https://dashboard.popupfox.com/register"
                    target="_blank"
                  >
                    Try Variant Page Builder Now ↗
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionFour;